import { z } from "zod";

export const playlistTagCreateSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
});

export const playlistTagUpdateSchema = z.object({
  name: z.string().min(1, "Name is required").optional(),
  description: z.string().optional(),
});

export type PlaylistTagFormData = z.infer<typeof playlistTagCreateSchema>;
export type PlaylistTagUpdateFormData = z.infer<typeof playlistTagUpdateSchema>;

export interface PlaylistTagRequest {
  name: string;
  description?: string;
}

export interface PlaylistTag {
  id: string;
  name: string;
  description?: string;
  tenantId?: string;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PlaylistTagsResponse {
  playlistTags: PlaylistTag[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface PlaylistTagFilters {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface UpdatePlaylistTagPayload {
  id: string;
  playlistTag: PlaylistTagUpdateFormData;
}
